import Box from '@mui/material/Box';
import {BlockQuote} from './BlockQuote';
import {PricingText} from './PricingText';
import {PlanOptionsCTA} from './PlanOptionsCTA';
import {AnnualPlanOptions, Product} from './Product.types';
import Button from '../common/Button';

type Props = {
  choices: Product[];
  setSelectedProduct: (priceId: string) => void;
  onValidationChanged: (valid: boolean) => void;
  onNext: (step?: number) => void;
  isAnnualPlan: AnnualPlanOptions;
};

export const AnnualPlan: React.FC<Props> = ({
  choices,
  setSelectedProduct,
  onValidationChanged,
  onNext,
  isAnnualPlan,
}) => {
  const {priceId, goToStep, title, ctaText, ctaFinePrint} = choices[0];
  const {quote, showQuote = false} = isAnnualPlan;

  const handleNext = (step?: number) => {
    onValidationChanged(true);
    onNext(step);
  };

  const selectPlan = () => {
    if (priceId) {
      setSelectedProduct(priceId);
      window.analytics.track('Onboarding SelectProduct', {priceId, title});
    }
    handleNext(goToStep);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: 400,
        width: '100%',
        mx: 'auto',
      }}>
      {showQuote && <BlockQuote text={quote} />}
      <PricingText ctaFinePrint={ctaFinePrint} />

      <Button sx={{width: '100%', marginBottom: '20px'}} onClick={selectPlan}>
        {ctaText || 'Start my 7-day free trial'}
      </Button>
      <PlanOptionsCTA
        ctaLabelText={isAnnualPlan.ctaLabelText}
        ctaText={isAnnualPlan.ctaText}
        onNext={() => handleNext(isAnnualPlan.goToStep)}
      />
    </Box>
  );
};
